/**
 * This barrel file provides the export for the shared NameListService.
 */
export * from "./util.service";



// WEBPACK FOOTER //
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/app/shared/services/util/index.ts